<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="iconfont icon-dingwei"></i> 人脸检测</div>
    <div class="main-shadow-box">
      <div v-if="!file" class="tip"><i class="el-icon-sunrise-1"></i> 请选择一张图片</div>
      <image-select @select="file = $event[0]"></image-select>
      <el-switch v-model="ifCheckAlive" style="margin-left: 10px;" active-text="是否活体检测"></el-switch><br/>
      <image-preview ref="imagePreview" :file="file" @update="detect"></image-preview>
      {{message}}<br/>
      <div v-if="ifCheckAlive&&checkMessage">活体检测结果：{{checkMessage | alive}}</div>
    </div>
  </div>
</template>
<script>
import ImageSelect from "@/components/image-select.vue";
import ImagePreview from "@/components/image-preview.vue";

export default {
  components: {
    ImageSelect,
    ImagePreview
  },
  data() {
    return {
      file: null,
      message: "",
      checkMessage: "",
      ifCheckAlive: false
    };
  },
  methods: {
    async detect({ file, canvas, percent }) {
      this.checkMessage = ""
      console.log(percent)

      if (!file) {
        return;
      }
      let res = await this.$request(this.$api.face1vs1.detect({ image: file }));
      if (res.length === 0) {
        this.message = "未检测到人脸";
        return;
      }
      this.message = '检测到人脸：' + JSON.stringify(res);
      let ctx = canvas.getContext("2d");
      ctx.save();
      ctx.strokeStyle = "white";
      for (let e of res) {
        if(percent>1){
          ctx.strokeRect(e.x/percent, e.y/percent, e.width/percent, e.height/percent);
        }else{
          ctx.strokeRect(e.x, e.y, e.width, e.height);
        }
      }
      ctx.restore();
      if(this.ifCheckAlive) {
        let checkRes = await this.$request(this.$api.face1vs1.checkAlive({ image1: file }))
        this.checkMessage = checkRes
      }
    }
  }
};
</script>

